import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getJourneyType } from "../../../../graphql/queries";
import { updateJourneyType } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as JourneyTypesConstants from "../../../../graphql/Constants/JourneyTypes/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";

const JourneyTypeEdit = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [updateButtonDisableStatus, setUpdateButtonDisableStatus] = useState(
    false
  );

  //#region update JourneyType business logic
  const handleUpdateJourneyType = async () => {
    try {
      // initial required JourneyType update data
      let input = {
        id: props.match.params.journeyTypeId,
        name: name.trim(),
        order: order
      };

      await API.graphql(graphqlOperation(updateJourneyType, { input }));
      return { result: true, message: `JourneyType updated successfully` };
    } catch (error) {
      return {
        result: false,
        message: `Error updating JourneyType, ${JSON.stringify(error, null, 2)}`,
      };
    }
  };
  //#endregion

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Edit}
      returnHandler={() => props.history.push(`/journeyTypes`)}
      modelName="JourneyType"
      getModelMethod={async () => {
        let result = await API.graphql(
          graphqlOperation(getJourneyType, { id: props.match.params.journeyTypeId })
        );
        if (result) {
          setName(result.data.getJourneyType.name);
          setOrder(result.data.getJourneyType.order);
        }
        return result.data.getJourneyType;
      }}
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === SkillsConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleUpdateJourneyType}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "JourneyType",
          false, // we need to exclude the OTHER
          setUpdateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={updateButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="JourneyType Name"
        placeholder="Enter a JourneyType name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "JourneyType",
            false, // we need to exclude the OTHER,
            setName,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="JourneyType Order"
        placeholder="Enter a JourneyType Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "JourneyType",
            setOrder,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default JourneyTypeEdit;
